import * as type from './types';
import { createReducer } from "../../util/index";

//Set the initial state for the current page , current limit and current search values
const initialState = {
    data: []
};

const cryptoReducer = createReducer(initialState) ({
    //Export the response to the react.js to get the response data based on type name
    [type.GET_CRYPTO_LIST]: (state = initialState, action) => ({
        ...state,
        crypto_data: action.payload
    }),

    [type.POST_CRYPTO]: (state, action) => ({
        ...state,
        post_crypto_result: action.payload,
    }),

    [type.GET_CRYPTO]: (state, action) => ({
        ...state,
        crypto_list_data: action.payload,
    }),

    [type.UPDATE_CRYPTO]: (state, action) => ({
        ...state,
        update_crypto_result: action.payload,
    }),

    [type.DELETE_CRYPTO]: (state, action) => ({
        ...state,
        delete_crypto_result: action.payload,
    }),

    [type.SHOW_CRYPTO]: (state, action) => ({
        ...state,
        show_crypto_data: action.payload,
    }),

    [type.UPDATE_STATUS_CRYPTO]: (state, action) => ({
        ...state,
        update_status_crypto_result: action.payload,
    })
});

export default cryptoReducer;